"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GMVSummary = exports.GMVSummaryQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.GMVSummaryQuery = typebox_1.Type.Object({
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    orderDateBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    orderDateAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.GMVSummary = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    orderID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    state: typebox_1.Type.String(),
    county: typebox_1.Type.String(),
    state_county: typebox_1.Type.String(),
    revenue: typebox_1.Type.Integer(),
    cost: typebox_1.Type.Integer(),
    profit: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    takeRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    lastUpdatedAt: typebox_1.Type.String({ format: 'date-time' }),
    orderDate: typebox_1.Type.String({ format: 'date-time' }),
    wayste_payable_upload: typebox_1.Type.Boolean(),
});
//# sourceMappingURL=gmv-summary.js.map